/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";
import _ from "lodash";

import { LoggerModule } from "@vlinder-web/logger-module-react";
//import { pretty } from '@vlinder-mobile/utils-rn';

import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";

//const jsConvert = require('js-convert-case');

const SERVICE_NAME = "ocr.service";

const is = require("is_js");

const log: any = LoggerModule?.getInstance();

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class OCRService {
    name = SERVICE_NAME;
    private static instance: OCRService;
    private api: AxiosInstance;
    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();

        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any) {
        if (!this.instance) {
            this.instance = new OCRService(props);
        }
        return this.instance;
    }
    async init() {}

    async getOCRResult(mfdBase64: any, barcode: string) {
        log.info("get mfd value ==>", mfdBase64?.substr(0, 50), barcode);
        let updatedBase64 = mfdBase64 && mfdBase64.split(",");

        updatedBase64 =
            updatedBase64 &&
            Array.isArray(updatedBase64) &&
            updatedBase64.length > 1 &&
            updatedBase64[updatedBase64.length - 1];
        log.blue(`updatedBase64 :`, updatedBase64?.substr(0, 50));
        try {
            let fssaiNO = "";
            let batch: any;
            let mfd = "";
            if (
                is.not.existy(updatedBase64) ||
                is.not.string(updatedBase64) ||
                is.empty(updatedBase64)
            ) {
                throw Error(`base64 data cannot be null or empty`);
            }

            //log.info(`Raj Base64 ==>`, mfdBase64);

            const res = await this.api.post(`trinetr/`, {
                content: updatedBase64,
                barcode:  barcode,
                type: "fssai_batch",
                isRoiRequired: true,
            });

            if (is.existy(res?.data)) {
                log.info(`third eye result 0 ==>`, res?.data);
                if (
                    is.existy(res?.data?.fssai?.lfssai) &&
                    is.existy(res?.data?.mfg?.lbatch)
                ) {
                    log.info(`third eye result 1 ==>`, res?.data);
                    if (
                        res.data.fssai.lfssai.length === 14 &&
                        res.data.fssai.lfssai !== "10013043000623"
                    ) {
                        // return res.data.lfssai;
                        fssaiNO = res.data.fssai.lfssai;
                    }

                    if (is.existy(res?.data?.mfg?.lbatch)) {
                        const batch_ =
                            res?.data?.mfg?.lbatch.match(/(\d[0-9]+)/g);
                        batch = batch_ && batch_[0];

                        const mfd_ = res?.data?.mfg?.lbatch.match(
                            /(0?[1-9]|[12]\d|30|31)[^\w\d\r\n:](0?[1-9]|1[0-2])[^\w\d\r\n:](\d{4}|\d{2}\\d{}([.\-/ ])\d{2}\2\d{2}|\d{2}([.\-/ ])\d{2}\3\d{4})/g
                        );
                        mfd = mfd_ && mfd_[0];
                    }

                    log.info(`Ocr Response ==>`, fssaiNO, batch, mfd);

                    return {
                        fssaiNO,
                        batch,
                        mfd,
                        gtin_desc: res?.data?.gtin_desc,
                        fssai_desc: res?.data?.fssai_desc,
                        barcode: res?.data?.barcode?.barcode_data ?? "",
                    };
                } else if (is.existy(res?.data?.fssai?.lfssai_raw)) {
                    let fssaiData: any =
                        res?.data?.fssai?.lfssai_raw.match(/(\d[0-9]+)/g);
                    log.info(`third eye result 2 ==>`, res?.data);

                    if (fssaiData) {
                        for (let i = 0; i < fssaiData.length; i++) {
                            /* 
                        Fssai Length is 14.
                        10013043000623 : Corporate No
                      */
                            if (
                                fssaiData[i].length === 14 &&
                                fssaiData[i] !== "10013043000623"
                            ) {
                                fssaiNO = fssaiData[i];
                                console.log("FSSAI No from Third Eye", fssaiNO);
                                return {
                                    fssaiNO,
                                    gtin_desc: res?.data?.gtin_desc,
                                    fssai_desc: res?.data?.fssai_desc,
                                };
                            }
                        }
                    }
                } else {
                    console.log("Fssai Number not found");
                    return {
                        fssaiNO,
                        gtin_desc: res?.data?.gtin_desc,
                        fssai_desc: res?.data?.fssai_desc,
                    };
                }
            }

            return fssaiNO;
        } catch (err: any) {
            log?.info(
                "Error in third eye ==>",
                JSON.stringify(
                    err?.response?.data?.error?.error_message ??
                        err?.response?.data?.error_message
                )
            );
            throw Error(
                err?.response?.data?.error?.error_message ??
                    err?.response?.data?.error_message
            );
        }
    }

    private report() {
        log?.info(`⚡⚡⚡===================⚡⚡⚡`);
        log?.info("Module Report");
        log?.info("⦿ Name: " + this.name);
        log?.info(`⚡⚡⚡===================⚡⚡⚡`);
    }
}
